import React, { useEffect, useState } from "react";
import Map, { Source, Layer, Marker, Popup, NavigationControl } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import axios from "axios";
import { URL_BASE } from "../../config/url-server";
import { Divider, Spin } from "antd";
import config from "../../config/config"; // Aquí debe estar tu token de Mapbox
import { Link } from "react-router-dom";
import { es } from "date-fns/locale/es";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import reportServices from "../../services/report-services";

import farmService from "../../services/farm-service";
import sectionService from "../../services/section-service";
import lotService from "../../services/lot-service";
import dashboardService from "../../services/dashboard-service";

import { ToastContainer, toast } from 'react-toastify';
import DatePicker from "react-datepicker";

import moment from "moment";

import { useForm } from "react-hook-form";

const CycleCompliance = () => {

    const [title, setTitle] = useState("Finca - Lote");

    const [viewState, setViewState] = useState({
        latitude: 5.391078, // Se actualizará dinámicamente
        longitude: -73.869958, // Se actualizará dinámicamente
        zoom: 5, // Zoom inicial
    });

    const referencePalmList = [
        { id: "firstPalm", name: "Primera palma del lote" },
        { id: "lastPalm", name: "Ultima palma del lote" },
        { id: "lastVisited", name: "Ultima palma visitada" }
    ];



    const [palmName, setPalmName] = useState("0");
    const [lineName, setLineName] = useState("0");
    const [startDateC1, setStartDateC1] = useState("");
    const [endDateC1, setEndDateC1] = useState("");
    const [startDateC2, setStartDateC2] = useState("");
    const [endDateC2, setEndDateC2] = useState("");
    const [startDateC3, setStartDateC3] = useState("");
    const [endDateC3, setEndDateC3] = useState("");
    const [daysC1, setDaysC1] = useState("");
    const [daysC2, setDaysC2] = useState("");
    const [daysC3, setDaysC3] = useState("");
    const [limit, setLimit] = useState(4);


    const [lotId, setLotId] = useState("0");
    const [sectionId, setSectionId] = useState("0");
    const [farmId, setFarmId] = useState("0");
    const [selectedPoint, setSelectedPoint] = useState(null); // Punto seleccionado para el popup
    const [lotPalmsLayer, setLotPalmsLayer] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [centerMap, setCenterMap] = useState({ lat: 10.5582, lng: -74.1915 });
    const [markerData, setMarkerData] = useState([]);
    const [popupInfo, setPopupInfo] = useState(null);
    const [loading, setLoading] = useState(false);

    const [tileset, setTileset] = useState(null);

    const clientId = localStorage.getItem("client");
    const accessToken = localStorage.getItem("token");



    const [showTable, setShowTable] = useState(false);
    const [palms, setPalms] = useState(0);
    const [totalFirstApplications, setTotalFirstApplications] = useState(0);
    const [initialDate, setInitialDate] = useState("");


    registerLocale("es", es);
    const start_date = moment().subtract(3, 'month').startOf('day').toDate();
    const end_date = moment().endOf("day").toDate();
    const [startDate, setStartDate] = useState(start_date);
    const [endDate, setEndDate] = useState(end_date);


    const [lotPalms, setLotPalms] = useState([]); // Puntos de todas las palmas del lote    
    const escoja = [{ _id: 0, name: "-ESCOJA-" }];
    const [listSection, setListSection] = useState(escoja);
    const [listFarms, setListFarms] = useState(escoja);
    const [listLots, setListLots] = useState(escoja);
    const [listUsers, setListUsers] = useState(escoja);






    const {
        register,
        getValues,
        setValue,
        formState: { errors },
    } = useForm();


    const getLisFarm = async () => {
        if (farmId == "0") {
            let listado = await farmService.getList();
            if (listado) {
                listado.push({ _id: 0, name: "-ESCOJA-" });
                const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                setListFarms(sortedItems);
                //setValue("farm",0)
            }
        }
    };




    const getListSection = async (e) => {
        const code = e.target.value;
        if (code == "0") {
            setListSection(escoja);
            setListLots(escoja);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
            return;
        }
        setFarmId(code)
        let listado = await sectionService.getListByFarm(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListSection(sortedItems);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
        }
    };



    const getLisLots = async (e) => {
        const code = e.target.value;
        if (code == "0") {
            setListLots(escoja);
            setValue("lot", "0")
            setValue("user", "0")
            return;
        }
        let listado = await lotService.getListBySection(code);
        setSectionId(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListLots(sortedItems);
            setValue("lot", "0")
            setValue("user", "0")
        }
    };




    const getDataCyclesPalm = async () => {

        setPalmName("0")
        setLineName("0")
        setLoading(true);
        let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
        let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
        const userId = getValues("userId")
        const reference = getValues("palm")

        const params = { startDate: start, endDate: end, farmId, lotId, sectionId, userId, limit, reference };
        const response = await dashboardService.cyclesByPalm(params);
        const cycles = response.data
        const rows = response.data
        setPalmName(response.palmName)
        setLineName(response.lineName)

        if (rows.length == 0) {
            toast.info(`EL lote no tiene ciclos completos`)
            setLoading(false);
            return;
        }

        if (rows.length < 3) {
            toast.info(`EL lote cuenta con ${rows.length} ciclos solamente`)
            setLoading(false);
            return;
        }
        loadLotPositions(cycles);
        setLoading(false);
    };



    const generateExcel = async () => {


        const lotId = getValues("lot");
        setPalmName("0")
        setLineName("0")
        setLoading(true);
        let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
        let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
        const userId = getValues("userId")
        const reference = getValues("palm")

        const params = { startDate: start, endDate: end, farmId, lotId, sectionId, userId, limit, reference };
        const response = await dashboardService.cyclesByPalm(params);
        const cycles = response.data
        const rows = response.data
        setPalmName(response.palmName)
        setLineName(response.lineName)

        if (rows.length == 0) {
            toast.info(`EL lote no tiene ciclos completos`)
            setLoading(false);
            return;
        }

        if (rows.length < 3) {
            toast.info(`EL lote cuenta con ${rows.length} ciclos solamente`)
            setLoading(false);
            return;
        }


        if (lotId == "0") {
            toast.error("Debe seleccionar un lote!", { autoClose: 1800 })
            return
        }
        const days = 160;
        const params2 = { lotId, days, cycles };
        setLoading(true);
        try {
            const response = await reportServices.cycleComplianceExcel(params2);
            if (response?.error) {
                toast.error("No hay registros", { autoClose: 1600 })
                setLoading(false);
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Cumplimiento de ciclos.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }




























    const loadLotPositions = async (cycles) => {
        try {
            setShowTable(false)
            const lotId = getValues("lot");


            if (lotId == "0") {
                toast.error("Debe seleccionar un lote!", { autoClose: 1800 })
                return
            }

            const days = 190;
            const params = { lotId, days, cycles };
            const configAxios = {
                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`,
                },
                params,
            };

            const response = await axios.get(URL_BASE + "map/cycle-compliance-map", configAxios);
            const palms = response.data.data;



            //return;


            const tilesetWeb = response.data.tileset;
            setTileset(tilesetWeb)

            const palmsPlantedWeb = response.data.palmsPlanted;
            setPalms(palmsPlantedWeb)


            const initialDateWeb = formatDate(response.data.initialDate);
            setInitialDate(initialDateWeb)



            if (palms.length > 0) {
                const middle = Math.floor(palms.length / 2);
                const coords = palms[middle]?.location?.coordinates;

                if (coords && coords.length === 2) {
                    const lat = coords[1];
                    const lng = coords[0];
                    setCenterMap({ lat, lng });

                    setViewState({
                        latitude: lat,
                        longitude: lng,
                        zoom: 17,
                    });
                }


            }

            setMarkerData(palms);





            let counter = 0;

            const filterCoord = palms.map((location, index) => {

                counter = counter + location.totalFirstApplications

                const [lng, lat] = location.location.coordinates;

                const value = location.totalFirstApplications;
                const name = ``;
                //const name = `${value}`;

                // Determinar el color según el valor
                let backgroundColor = location.color

                const colorLabel = "#000";

                return (
                    <Marker
                        key={`lot-palm-${index}`}
                        longitude={lng}
                        latitude={lat}
                        anchor="center"
                    >
                        <div
                            onClick={() => setSelectedPoint(location)}
                            style={{
                                width: "14px",
                                height: "14px",
                                borderRadius: "50%",
                                backgroundColor: backgroundColor,
                                border: "1px solid #000",
                                cursor: "pointer",
                            }}
                            title={name}
                        />
                    </Marker>
                );
            });



            setTotalFirstApplications(counter)
            setLotPalmsLayer(filterCoord)
            setShowTable(true)





        } catch (error) {
            console.error("Error obteniendo las palmas:", error);
        } finally {
            setLoading(false);
        }
    };


    const isValidCoordinate = (coord) => {


        return (
            Array.isArray(coord) &&
            coord.length === 2 &&
            typeof coord[0] === 'number' &&
            typeof coord[1] === 'number' &&
            !isNaN(coord[0]) &&
            !isNaN(coord[1])
        );
    };


    const formatDate = (dateString) => {
        return moment(dateString).locale('es').format('DD MMM');
    };


    useEffect(() => {
        const farm_name = localStorage.getItem("farmName");
        const lot_name = localStorage.getItem("lotName");
        setTitle(`FINCA ${farm_name} - ${lot_name}`);
        getLisFarm();
    }, []);

    return (
        <div >

            <ToastContainer />





            <div className="row">


                <div className="col-12 col-sm-2">

                    <div className="col-12 ml-4 ms-2" style={{ marginTop: "-10px" }}>
                        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Cumplimiento</Divider>
                    </div>

                    <form className="form-react">
                        <div className="row ms-2">




                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Finca</label>
                                <select
                                    className="form-control text-secondary"

                                    {...register("farm")}
                                    onChange={(e) => getListSection(e)}
                                >
                                    {listFarms.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="  col-12 col-sm-12">
                                <label className="text-secondary fw-bold">Sección</label>
                                <select
                                    className="form-control text-secondary"
                                    {...register("section")}
                                    {...register("section")}
                                    onChange={(e) => getLisLots(e)}
                                >
                                    {listSection.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Lote</label>
                                <select
                                    className="form-control text-secondary"
                                    {...register("lot")}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setLotId(value);
                                    }}
                                >
                                    {listLots.map((option) => (
                                        <option key={option._id} value={option._id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className=" col-12">
                                <label className="text-secondary fw-bold">Palma de referencia</label>
                                <select className="form-control" {...register("palm")}>
                                    {referencePalmList.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>





                            <div className=" col-12">
                                <label className="text-secondary fw-bold">&nbsp;</label>
                                <br />
                                <Spin spinning={loading}>
                                    <button
                                        className="btn btn-primary w-100"
                                        type="button"
                                        onClick={() => getDataCyclesPalm()}
                                    >
                                        <i className="bi bi-search fa-lg m-2" /> Buscar
                                    </button>

                                </Spin>

                            </div>


                            <div className=" col-12 mb-4">
                                <label className="text-secondary fw-bold">&nbsp;</label>
                                <br />
                                <Spin spinning={loading}>
                                    <button
                                        className="btn btn-info w-100"
                                        type="button"
                                        onClick={() => generateExcel()}
                                    >
                                        <i className="bi bi-file-earmark-text fa-lg m-2" /> Exportar
                                    </button>
                                </Spin>
                            </div>




                        </div>
                    </form>





                    <div className="col-12 m-3">

                        <h6 style={{ fontWeight: "bold", marginBottom: "8px" }}>Leyenda de colores</h6>
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: "#FFFFFF", border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>Sin aplicaciones</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: "#00FF00", border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>Perfecto</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: "#FFD24D", border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>Interrumpido</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ width: "20px", height: "20px", backgroundColor: "#FF0000", border: "1px solid #aaa", borderRadius: "4px" }}></span>
                                <span>Crítico</span>
                            </div>
                        </div>

                    </div>

                    <div className={showTable ? "col-12 ms-2 p-2" : "d-none"}>
                        <table className="table table-bordered table-striped table-hover table-sm text-center">

                            <tbody>


                                <tr className="table-primary">
                                </tr>

                                <tr>
                                    <td><b>Palmas</b></td>
                                    <td>{palms.toLocaleString()}</td>
                                </tr>

                            </tbody>


                        </table>
                    </div>






                </div>



                <div className="col-12 col-sm-10">
                    <Map
                        {...viewState} // Aplicar el estado de la vista dinámica
                        onMove={evt => setViewState(evt.viewState)} // Permitir mover el mapa
                        style={{ width: "100%", height: "100vh" }}
                        mapStyle="mapbox://styles/mapbox/satellite-v9" // Mapa satelital
                        mapboxAccessToken="pk.eyJ1IjoianVhbmNwaW5lZGFtIiwiYSI6ImNtNXlyNmxtbjBubm0ya3B5ZHVnMWgwcWYifQ.dogzl3DX9PMO9QywZ8CbyA"
                    >

                        <NavigationControl position="top-left" />

                        {lotPalmsLayer}

                        {selectedPoint && selectedPoint.location?.coordinates && (
                            <Popup
                                longitude={selectedPoint.location.coordinates[0]}
                                latitude={selectedPoint.location.coordinates[1]}
                                onClose={() => setSelectedPoint(null)}
                                closeOnClick={false}
                            >
                                <div>

                                    <p className="text-success" ><strong>Linea-Palma</strong></p>
                                    <strong>Línea:</strong> {selectedPoint.lineName || "N/A"}<br />
                                    <strong>Palma:</strong> {selectedPoint.palmName || "N/A"}<br />
                                    <strong> {selectedPoint.status || "N/A"}</strong><br />
                                    <strong> {selectedPoint.totalFirstApplications} -  {selectedPoint.totalSecondApplications} -  {selectedPoint.totalThirdApplications} </strong>
                                </div>
                            </Popup>
                        )}


                        {tileset && (
                            <>
                                <Source
                                    id="ortomosaico"
                                    type="raster"
                                    url={`mapbox://${tileset}`}
                                    tileSize={256}
                                />
                                <Layer
                                    id="ortomosaico-layer"
                                    type="raster"
                                    source="ortomosaico"
                                    paint={{ "raster-opacity": 1 }}
                                />
                            </>
                        )}

                    </Map>

                </div>



            </div>




        </div>
    );
};

export default CycleCompliance;
